import { useMutation } from "@tanstack/react-query";
import { customAxios } from "lib/axios";
import { showNotification } from "@mantine/notifications";
import { AxiosError } from "axios";

interface ChangePasswordResponse {
  success: boolean;
  message: string;
  newPassword?: string;
}

export const useChangeUserPassword = () =>
  useMutation<
    ChangePasswordResponse,
    AxiosError<{ message?: string }>,
    { userId: string; newPassword: string }
  >({
    mutationFn: async ({ userId, newPassword }) => {
      const response = await customAxios.post<ChangePasswordResponse>(
        `/users/${userId}/change-password`,
        { newPassword }
      );
      return response.data;
    },
    onSuccess: (data) => {
      showNotification({
        title: "Success",
        message: "Password changed successfully",
        color: "green",
      });
    },
    onError: (error: AxiosError<{ message?: string }>) => {
      const errorMsg =
        error?.response?.data?.message || "Failed to change password";
      showNotification({
        title: "Error",
        message: errorMsg,
        color: "red",
      });
    },
  });
